import { CancelOutlined } from "@spoctech/icons";
import {
  chipClasses,
  ChipIconVariants,
  ChipVariants,
  iconClasses,
} from "./Chip.style";

export type ChipProps = ChipVariants &
  ChipIconVariants & {
    label: string;
    className?: string;
    onDelete?: () => void;
  };

function Chip(props: ChipProps) {
  const { size, variant, label, color, className, onDelete, ...rest } = props;

  return (
    <div
      {...rest}
      className={chipClasses({
        variant,
        color,
        class: className,
      })}
    >
      <span className="pr-1">{label}</span>
      {Boolean(onDelete) && (
        <CancelOutlined
          className={iconClasses({
            size,
            variant,
            color,
            class: className,
          })}
        />
      )}
    </div>
  );
}

export default Chip;
